export default {"src":"/_next/static/media/ecommerceLogo3.1f5aabb4.svg","height":36,"width":127,"blurWidth":0,"blurHeight":0};